import React, { Component } from 'react';

export default class DonationsMeta extends Component {
    render() {
        if(this.props.currentDonation) {
            return(
                <ul style={{margin: 0, padding: '0 1rem'}} className="flex flex-col gap-2">
                    {this.props.currentDonation.donations_over_20000_same_donor ?
                        <li style={{fontSize: '1rem'}}>Har modtaget donationer fra samme donator, der overstiger 20.000 kr.</li>: null}
                        {parseInt(this.props.currentDonation.amount_total) === 0 ? <li style={{fontSize: '1rem'}}>Har ikke modtaget donationer</li> : null}
                </ul>
            )
        } else {
            return (
                <ul style={{margin: 0, padding: '0 1rem'}} className="flex flex-col gap-2">
                    {this.props.currentAnnualReportContent.donations == 'in_annual_report' ? <li style={{fontSize: '1rem'}}>Donationer fremgår af årsregnskab</li> : null}
                    {this.props.currentAnnualReportContent.donations == 'none' ? <li style={{fontSize: '1rem'}}>Har ikke modtaget donationer</li> : null}
                    {this.props.currentAnnualReportContent.donations_greater_than20000 ?
                        <li style={{fontSize: '1rem'}}>Har modtaget donationer fra samme
    donator, der overstiger 20.000 kr.</li>: null}
                </ul>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/reports/DonationsMeta.js